import React from 'react';
import './CommunityEngagement.css';

const CommunityEngagement = () => {
  return (
    <div className="engagement">
      <div className="engagement-wrapper">
        <h2 className="engagement-title">🤝 Community Engagement</h2>
        <p className="engagement-intro">
          At Igbo-Eze North, development begins with the people. Our Council is deeply committed to inclusive governance, where every resident has a voice in shaping the future of our communities. Through regular consultation, grassroots partnerships, and feedback mechanisms, we ensure that public policies reflect the real needs and aspirations of the people.
        </p>

        <section className="engagement-section">
          <h3>🗣️ Public Participation</h3>
          <ul>
            <li>Town Hall Meetings in all 20 wards</li>
            <li>Stakeholder forums with traditional rulers, NGOs, youth, and women groups</li>
            <li>Pre-budget consultations to gather input before finalizing spending plans</li>
            <li>Development Centre meetings for hyper-local planning and feedback</li>
          </ul>
          <p>These platforms foster transparency, build trust, and promote citizen ownership of projects and programmes.</p>
        </section>

        <section className="engagement-section">
          <h3>🧭 Community-Led Planning</h3>
          <p>The 2025–2029 Medium Term Development Plan was developed with input from:</p>
          <ul>
            <li>Traditional authorities (Igwe, Onyishi, Town Union Presidents)</li>
            <li>Market and artisan associations</li>
            <li>Women’s groups, youth councils, and persons with disabilities</li>
            <li>Faith-based and community-based organizations</li>
            <li>Private sector representatives</li>
          </ul>
          <p>This inclusive approach ensures that no one is left behind in our journey toward sustainable development.</p>
        </section>

        <section className="engagement-section">
          <h3>📨 Citizen Feedback</h3>
          <p>We’ve established simple ways for residents to voice concerns, share ideas, and report service issues:</p>
          <ul>
            <li>Website contact form and email address</li>
            <li>Dedicated lines at Development Centres</li>
            <li>Feedback boxes at Council offices and public locations</li>
            <li>(Coming soon): SMS/WhatsApp-based citizen reporting channel</li>
          </ul>
          <p>All feedback is reviewed by the Planning and Public Service Delivery Unit, and relevant departments are tasked with timely follow-up.</p>
        </section>

        <section className="engagement-section">
          <h3>💡 Ongoing Initiatives</h3>
          <ul>
            <li>Social Accountability Campaigns on service delivery and budget tracking</li>
            <li>Community Scorecards for schools, health centres, and road projects</li>
            <li>Partnerships with NGOs on advocacy, peacebuilding, and inclusion</li>
            <li>Annual Open Governance Day to review progress and hear from citizens</li>
          </ul>
        </section>

        <p className="engagement-conclusion">
          🙋‍♂️ <strong>Have something to say? We’re listening.</strong><br />
          Visit the <strong>Contact</strong> page, send us a message, or speak to your ward councillor or Development Centre head.
        </p>
      </div>
    </div>
  );
};

export default CommunityEngagement;